import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgBeachChairOwlLookingUp: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 161 133" {...props}>
    <path
      d="M154.06 93.33l-20.81-1.56-38.4-2.82-57.4-3.02c-.54-.23-1.42-.18-2.28.08l-5.2.2c-1.18.05-2.6.68-3.16 1.39-.58.7-.1 1.25 1.07 1.23l1.87-.04c-5.34 2.82-18.4 11.2-23.31 13.35l-3.19-.19c-.93-.05-2.13.31-2.68.8-.55.5-.25.93.67 1l6.96.54c3.89 2.13 8.18 3.8 12.7 5.12l13.46 15.2 4.03-2.01-9.67-11.75c13.73 3.55 25.85 3.97 35.27.53l-5.77 2.44c-.03.12-.08.23-.13.34l16.65 4.46 45.8 12.73c1.46.59 3.04.9 4.38.91 1.24.02 2.26-2.13 2.8-2.64 1.1-1.1-.37-2.93-3.25-4.02l-44.93-12.59 32.3-18.04 38.5 4.26c1.62.36 3.32.34 4.73 0 1.3-.3 2.35-.9 2.86-1.69 1.05-1.7-.71-3.61-3.87-4.21zm-53.34.61l-.41.07.52-.15-.11.08z"
      fill="#b8b8b8"
    />
    <path
      d="M156.44 98.7a3.7 3.7 0 01-2.7-1.18l-85-91a3.7 3.7 0 115.4-5.05l85 91a3.7 3.7 0 01-2.7 6.22z"
      fill="#a85009"
    />
    <path
      d="M147.85 64.63c-.42.1-.9.19-1.45.5l-72 33a3.7 3.7 0 003.08 6.73l72-33c.86-.32 1.24-.7 1.63-1.1l-3.26-6.13z"
      fill="#a85009"
    />
    <path d="M137.44 69.19l1.02-.5s1.4 1.76 3.14 3.65c2.04 2.2 5.02.8 5.02.8l-4.2 1.98-4.98-5.93z" fill="#7e3c06" />
    <ellipse transform="rotate(-25.68 149 67.98)" cx={148.98} cy={67.98} rx={2.22} ry={3.67} fill="#d2a47f" />
    <path d="M26.94 26a3.7 3.7 0 01-.8-7.32l50-11a3.7 3.7 0 011.6 7.23l-50 11c-.27.06-.54.09-.8.09z" fill="#a85009" />
    <path d="M103.44 84.82L74.4 98.13a3.7 3.7 0 003.08 6.73l25.96-11.9v-8.14z" fill="#7e3c06" />
    <path d="M93.44 100a3 3 0 01-1.42-5.64l41-22a3 3 0 012.84 5.28l-41 22a3 3 0 01-1.42.36z" fill="#ffe539" />
    <path d="M93.44 100a3 3 0 01-1.42-5.64l41-22a3 3 0 112.84 5.28l-41 22a3 3 0 01-1.42.36z" fill="#5ec0ff" />
    <path
      d="M26.04 26.67c-.27-1.13.27-2.09.75-2.93l.31-.6-1.2.36-.12.25c-.46.9-1.1 2.14-.76 3.61 6.42 27.88 18.32 47.22 35.38 58.9 17.47 11.97 34.28 10.52 34.28 10.52l.87-1.48c-9.88-.19-54.08-3.74-69.51-68.63z"
      fill="#009dff"
    />
    <path
      d="M24.45 19.8l52.8-10.03s11.46 49.95 52.63 62.69c1.1.34 2.22.65 3.37.93L93.78 95.34S43.13 100 26.17 26.94c-.54-2.32 4.12-4.45-1.72-7.13z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#5ec0ff"
    />
    <path
      d="M22.7 19.3s2.24-.44 3.18 2.96.1 3.94.1 3.94l.69 2.56L78.69 16.3s.23-8.44-4.3-8.03c-4.53.41-51.69 11.04-51.69 11.04z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#5ec0ff"
    />
    <g fill="#009dff">
      <path d="M26.94 26.55a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.48-.1c.14-.03.27.05.3.18a.25.25 0 01-.19.3l-.49.1-.05.02zM29.39 26a.25.25 0 01-.24-.19.25.25 0 01.19-.3l.98-.21c.13-.03.27.05.3.19a.25.25 0 01-.2.3l-.98.21h-.05zm2.94-.64a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.13-.03.27.06.3.19a.25.25 0 01-.2.3l-.97.21h-.06zm2.94-.65a.25.25 0 01-.05-.5l.98-.2c.13-.04.27.05.3.18a.25.25 0 01-.2.3l-.97.22h-.06zm2.94-.64a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.14-.03.27.05.3.19a.25.25 0 01-.2.3l-.97.2-.06.02zm2.95-.65a.25.25 0 01-.25-.2.25.25 0 01.2-.3l.97-.21c.14-.03.27.05.3.19s-.06.27-.19.3l-.98.21h-.05zm2.94-.65a.25.25 0 01-.06-.5l.98-.2c.14-.04.27.05.3.18a.25.25 0 01-.19.3l-.98.21-.05.01zm2.94-.65a.25.25 0 01-.24-.2.25.25 0 01.19-.29l.97-.22c.14-.03.27.06.3.2a.25.25 0 01-.19.3l-.98.2-.05.01zm2.94-.64a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.13-.03.26.05.3.19a.25.25 0 01-.2.3l-.98.21h-.05zm2.94-.65a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.13-.03.26.06.3.19a.25.25 0 01-.2.3l-.98.21-.05.01zm2.94-.65a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.2c.14-.04.27.05.3.18a.25.25 0 01-.2.3l-.97.22h-.06zm2.94-.64a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.14-.03.27.05.3.19a.25.25 0 01-.2.3l-.97.2-.06.02zm2.95-.65a.25.25 0 01-.25-.2.25.25 0 01.2-.3l.97-.21c.13-.03.27.05.3.19a.25.25 0 01-.19.3l-.98.21h-.05zm2.94-.65a.25.25 0 01-.25-.2.25.25 0 01.2-.3l.97-.2c.14-.03.27.05.3.18a.25.25 0 01-.19.3l-.98.21-.05.01zm2.94-.65a.25.25 0 01-.25-.2.25.25 0 01.2-.29l.97-.22c.14-.02.27.06.3.2a.25.25 0 01-.19.3l-.98.2-.05.01zm2.94-.64a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.98-.21c.13-.03.26.05.3.19a.25.25 0 01-.2.3l-.98.21h-.05zm2.94-.65a.25.25 0 01-.05-.5l.98-.21c.13-.03.27.06.3.19a.25.25 0 01-.2.3l-.98.21h-.05zM76.45 15.65a.25.25 0 01-.24-.2.25.25 0 01.19-.3l.49-.1c.13-.03.26.06.3.2a.25.25 0 01-.2.29l-.48.1-.06.01z" />
    </g>
    <path
      d="M93.44 100a3 3 0 01-1.42-5.64l41-22a3 3 0 014.06 1.22 3 3 0 01-1.22 4.06l-41 22a3 3 0 01-1.42.36z"
      fill="#a85009"
    />
    <path
      d="M137.3 75.87l.01-.02c.22-.73.16-1.55-.23-2.27a3 3 0 00-2-1.52 2.97 2.97 0 00-.42-.05c.53.23 1.73.88 1.97 2.16.08.43.1.37.1.75l-3 1.5-.64 2.7 2.77-1.48a2.95 2.95 0 001.43-1.77z"
      fill="#7e3c06"
    />
    <path d="M91.44 101a3 3 0 01-1.42-5.64l40.64-21.8a3 3 0 112.83 5.28l-40.63 21.8a3 3 0 01-1.42.36z" fill="#5ec0ff" />
    <path fill="#5ec0ff" d="M130.36 72.6l2.89.79.57 1.36-5.39-.58z" />
    <path
      d="M85.09 104.32a3 3 0 01-1.42-5.64l8.35-4.33a3 3 0 112.84 5.29l-8.36 4.32a3 3 0 01-1.41.36z"
      fill="#a85009"
    />
    <path
      d="M119.44 76c-3.02-2.42-3.88.23-14.38-.67 2.95-9.07 4.69-26.89-18.82-41.13-30.76-18.65-44.14-6.01-46.63 7.13-.18.96-.3 1.92-.37 2.87-1 14 15.16 41.58 39.2 44.8 23.34 3.12 46-9 41-13z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#009dff"
    />
    <path d="M35.44 27c1.18-2.94 13 1 13 1l2 13h-11s-6-9-4-14z" fillRule="evenodd" clipRule="evenodd" fill="#009dff" />
    <path
      d="M77 4.28c2.95.8 5.31 2.78 7.39 5.33a31.34 31.34 0 014.54 7.86l-15.94 1.77c.84-2.65.98-10.6 1.82-13.26 0 0 .44-2.17 2.18-1.7z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#ff7300"
    />
    <path
      d="M48.05 23.74C60.35 11.29 75.07 8.58 79.97 8.31c20.76-1.17 34.93 11.32 41.93 26.54 9.75 21.24-3.54 42.45-22.24 49.5C80 91.73 60.19 85.7 48.05 66.04c-5.3-8.57-6.19-16.18-5.74-25.93a41.33 41.33 0 01-4.73-13.77s-1.4-5.06 10.47-2.61z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#ff7300"
    />
    <g fillRule="evenodd" clipRule="evenodd" fill="#d85700">
      <path d="M38.42 30.03l-.17-.3.16.63.02-.33zM102.78 77.54c-21.93 7.79-44.12 1.26-57.8-19.8-.6-.9-1.12-1.8-1.62-2.7.88 3.66 2.36 7.25 4.68 11.01C60.2 85.71 80 91.74 99.66 84.34c9.27-3.49 17.2-10.46 21.67-19.2-4.93 5.52-11.38 9.85-18.55 12.4z" />
    </g>
    <path
      d="M40.26 35.85a41.4 41.4 0 002.05 4.27c-.13 2.66-.14 5.15 0 9.56L76.36 86c2.94-1.69 8.91 1.46 11.95 1.12L40.26 35.85z"
      fill="#d85700"
    />
    <path
      d="M103.27 43.02c-.99-2.52-2.77-5.25-3.35-7.46 2.07.16 5.46 1.34 7.3 1.95 1.74.57 5.2 2.24 5.5 2.5a17.03 17.03 0 00-1.94 4.55c-.43 1.76-.4 3.74-.98 4.7-.26.42.43.03-.02.19-.46.16-5.96-5.03-6.51-6.43z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#d85700"
    />
    <path
      d="M109.95 49.48a26.87 26.87 0 01-.25-6.78c.1-.66.07-1.55.16-2.19-1.22 1.5-2.3 3.53-3.43 5.62-.08.1-.1.24-.1.36.03.14.1.26.19.36a7.67 7.67 0 003.44 2.63"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#f2f2f2"
    />
    <path
      d="M105.07 45.35a26.53 26.53 0 01-5.15-9.8c2.03.18 4.03.6 5.96 1.25 1.79.67 3.5 1.53 5.11 2.55l-3.55 5.82c-.26.42-.54.87-1 1.03-.47.16-1.03-.37-1.37-.85"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path
      d="M93.86 48.54c-5.17 4.72-13.75 3.85-19.15-1.95s-5.58-14.32-.4-19.03 13.75-3.85 19.15 1.95 5.58 14.32.4 19.03z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#d85700"
    />
    <path
      d="M93.68 50.31c-5.18 4.72-13.76 3.85-19.16-1.95s-5.58-14.31-.4-19.03 13.76-3.85 19.16 1.95 5.58 14.32.4 19.03z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path
      d="M106.8 17.94c4.73 3.6 7 9.56 4.01 12.66s-8.97 2.35-13.35-1.67-5.64-9.92-2.51-12.88c2.87-2.71 7.19-1.64 11.85 1.9z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#d85700"
    />
    <path
      d="M106.83 19.31c4.73 3.59 7 9.56 4.01 12.66-3 3.1-8.97 2.35-13.35-1.67s-5.65-9.92-2.51-12.88c2.86-2.72 7.19-1.65 11.85 1.9z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path
      d="M75.18 74.3c6.32 1.54 6.86-2.7 6.86-2.7 8.39-1.16 5.38-6.93 5.38-6.93 3.13-4.07-1.4-6-1.4-6-12.44-1.14-21.08 4.87-21.08 4.87-2.82 8.55 10.24 10.76 10.24 10.76z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#d85700"
    />
    <path
      d="M74.26 73.56c5.82 1.44 6.3-2.48 6.3-2.48 7.72-1.05 4.94-6.4 4.94-6.4 2.87-3.77-1.3-5.56-1.3-5.56-11.46-1.1-19.4 4.45-19.4 4.45-2.57 7.9 9.46 9.98 9.46 9.99z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#ff7300"
    />
    <path
      d="M40.16 122.59h-.06a3 3 0 01-2.94-3.06l1.56-79.19a3 3 0 013-2.94h.06a3 3 0 012.94 3.06l-1.56 79.19a3 3 0 01-3 2.94z"
      fill="#a85009"
    />
    <path
      d="M38.68 45.07l4.06 4.9s1.51 1.92 1.63 4.45v-8.25l-5.69-5.53v4.43z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#7e3c06"
    />
    <g fill="#009dff">
      <path d="M89.64 92.08a.25.25 0 01-.22-.14.25.25 0 01.1-.34l.46-.22c.12-.06.27-.01.33.11.06.13.01.28-.11.34l-.45.22a.24.24 0 01-.1.03zM91.83 90.99a.25.25 0 01-.23-.14.25.25 0 01.11-.34l.87-.43c.12-.06.28-.01.34.11s.01.27-.11.34l-.87.43a.23.23 0 01-.11.03zm2.6-1.3a.25.25 0 01-.22-.14.25.25 0 01.11-.34l.87-.43c.12-.06.27-.01.34.11s0 .27-.12.34l-.86.43a.24.24 0 01-.11.03zm2.61-1.3a.25.25 0 01-.22-.14.25.25 0 01.11-.34l.87-.43c.12-.06.27-.02.33.1.07.13.02.28-.1.34l-.88.44a.24.24 0 01-.1.03zm2.61-1.3a.25.25 0 01-.22-.15.25.25 0 01.1-.33l.88-.43c.12-.06.27-.02.33.1.06.13.01.28-.11.34l-.87.44a.24.24 0 01-.11.02zm2.6-1.3a.25.25 0 01-.22-.15.25.25 0 01.12-.33l.86-.44c.12-.06.28 0 .34.12s.01.27-.11.33l-.87.43a.24.24 0 01-.11.03zm2.62-1.31a.25.25 0 01-.23-.14.25.25 0 01.11-.33l.87-.44a.25.25 0 01.34.11c.06.13.01.28-.11.34l-.87.43a.23.23 0 01-.11.03zm2.6-1.3a.25.25 0 01-.22-.14.25.25 0 01.11-.34l.87-.43a.25.25 0 01.34.11c.06.13 0 .28-.12.34l-.87.43a.24.24 0 01-.1.03zm2.61-1.3a.25.25 0 01-.22-.14.25.25 0 01.11-.34l.87-.43a.25.25 0 01.33.11c.07.12.02.27-.1.34l-.88.43a.24.24 0 01-.1.03zm2.6-1.3a.25.25 0 01-.22-.14.25.25 0 01.12-.34l.87-.43a.25.25 0 01.33.1c.06.13.01.28-.11.34l-.87.44a.24.24 0 01-.11.03zm2.62-1.3a.25.25 0 01-.23-.15.25.25 0 01.12-.33l.86-.43c.12-.06.28-.02.34.1.06.13.01.28-.11.34l-.87.44a.23.23 0 01-.11.02zm2.6-1.3a.25.25 0 01-.22-.15.25.25 0 01.11-.33l.87-.43c.12-.06.27-.02.34.1.06.13 0 .28-.12.34l-.86.44a.24.24 0 01-.11.02zm2.61-1.3a.25.25 0 01-.22-.15.25.25 0 01.11-.33l.87-.44c.12-.06.27 0 .34.12.06.12 0 .27-.12.33l-.87.43a.24.24 0 01-.1.03zm2.61-1.31a.25.25 0 01-.22-.14.25.25 0 01.1-.33l.88-.44c.12-.06.27-.01.33.11.07.13.02.28-.1.34l-.88.43a.24.24 0 01-.1.03zM125.73 74.07a.25.25 0 01-.23-.14.25.25 0 01.12-.34l.44-.22a.25.25 0 01.34.11c.06.12.01.27-.11.34l-.45.22a.23.23 0 01-.11.03z" />
    </g>
    <path
      d="M124.44 131.7c-.99 0-1.97-.4-2.7-1.17l-105-112a3.7 3.7 0 015.4-5.07l105 112a3.7 3.7 0 01-2.7 6.23z"
      fill="#a85009"
    />
    <path
      d="M103.14 99.9l-2.83-3.19-7.07 3.29 6.28 7s-2.37-2.05-1.38-3.92 5-3.18 5-3.18z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#7e3c06"
    />
    <path
      d="M34.94 127.2a3.7 3.7 0 01-1.54-7.07l72-33a3.7 3.7 0 113.08 6.73l-72 33c-.5.23-1.02.34-1.54.34z"
      fill="#a85009"
    />
    <ellipse transform="rotate(-25.68 107.61 90.25)" cx={107.61} cy={90.24} rx={3} ry={3.82} fill="#d2a47f" />
    <path
      d="M86.66 34.1c-1.14 1.22-3.25 1.22-4.7 0-1.45-1.24-1.7-3.23-.56-4.46s3.24-1.23 4.7 0c1.45 1.24 1.7 3.23.56 4.46zM101.12 22c-.94 1.05-2.7 1-3.92-.13-1.22-1.13-1.44-2.9-.5-3.96s2.7-1 3.93.13c1.22 1.13 1.44 2.9.5 3.96z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#404040"
    />
  </svg>
);
/* eslint-enable max-len */

export default SvgBeachChairOwlLookingUp;
